import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import AdNav from "../components/adNav";
import Time from "../components/time";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";

const ModifySupplier = () => {
  const { sCode, itemCode, sName, id } = useParams();
  const branch = localStorage.getItem("branch");
  const user = localStorage.getItem("username");
  const [code, setCode] = useState(""); 
  const [subDetails, setSubDetails] = useState({});
  const [formData, setFormData] = useState({
    heading: "",
    desc: "",
    expiryDate: "",
    heading: "",
    content: "",
  });
  const navigate = useNavigate();

  useEffect(() => {
    const fetchSupplierDetails = async () => {
      try {
         Swal.fire({
                      title: "Loading Flash News Details",
                      html: `
                        <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
                          <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
                        </div>
                        <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch Flash News Details...</p>
                      `,
                      showConfirmButton: false,
                      allowOutsideClick: false,
                      didOpen: () => {
                        const style = document.createElement("style");
                        style.innerHTML = `
                          @keyframes progressBar {
                            0% { width: 0% }
                            50% { width: 100% }
                            100% { width: 0% }
                          }
                        `;
                        document.head.appendChild(style);
                      },
                    });
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/flashNews_editFetch?slNo=${id}`);
        const items = response.data.fetchData;
        console.log(response.data.fetchData);
        
  
        if (items.length > 0) {
          const item = items[0];
          const storeReqHeader1 = {
            heading: item.Heading || "N/A",
            content: item.Message || "N/A",
            expiryDate: item.Expired_Date || "0",
            desc: item.Description || "0",
            date: item.News_EntryDate || "0",
          };
  
          setSubDetails(storeReqHeader1);
          setFormData({
            heading: storeReqHeader1.heading,
            content: storeReqHeader1.content,
            expiryDate: storeReqHeader1.expiryDate,
            desc: storeReqHeader1.desc,
            date: storeReqHeader1.date,
          });
        }
        Swal.close();
      } catch (error) {
         Swal.close();
                          console.error("Error fetching Flash News Details:", error);
                          Swal.fire({
                            icon: "error",
                            title: "Oops!",
                            text: "Error fetching Flash News Details. Please try again.",
                          });
      }
    };
  
    fetchSupplierDetails();
}, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {
        message: formData.content,
        desc: formData.desc,
        heading: formData.heading,
        expiryDate : formData.expiryDate,
        slNo: id,
    };
    console.log(payload);
    

    try {
          Swal.fire({
                            title: "Submitting...",
                            text: "Please wait while we process your request.",
                            allowOutsideClick: false,
                            didOpen: () => {
                                Swal.showLoading();
                            },
                        });

        const response = await axios.put("https://rfs2.infraconsoft.net.in/api/flashNews_edit", payload);
        Swal.fire("Success", response.data.message, "success");
        navigate(`/admin/flashnewslist`);
    } catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
            Swal.fire("Error", error.response.data.message, "error");
        } else {
            Swal.fire("Error", "Submission failed. Please try again.", "error");
        }
    }
  };

  return (
    <div id="admin-container">
      <AdNav />
      <div className="content-right">
        <section>
          
          <div className="back-div">
                  <h2 className="add-txt">Flash News - Edit</h2>
                  <Link to={`/admin/flashnewslist`}><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                  </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>

          <div className="form-row">
              <div className="form-group">
                <label>Enter the Headline:</label>
                <input type="text" name="heading" value={formData.heading} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>Enter Short Description:</label>
                <input type="text" name="desc" value={formData.desc} onChange={handleInputChange} />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Current Date:</label>
                <input type="date" value={new Date().toISOString().split("T")[0]} readOnly />
              </div>
              <div className="form-group">
                <label>Expiry Date:</label>
                <input
  type="date"
  name="expiryDate"
  value={formData.expiryDate ? formData.expiryDate.split("T")[0] : ""}
  onChange={handleInputChange}
/>

              </div>
            </div>

            <div className="form-group">
  <label>Flash News Content:</label>
  <textarea
    name="content"
    value={formData.content}
    onChange={handleInputChange}
    rows="5"
    style={{ width: "100%", padding: "10px" }}
  ></textarea>
</div>

          
            <div className="btn-cls">
              <button type="submit" className="submit-btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ModifySupplier;
